import { getNativePort } from 'utils/printer/networkPrinterUtils';

export function isInApp(): boolean {
  return !!getNativePort() || window?.location.hash.indexOf('fakeIsInApp') !== -1;
}
